intra_module.controller('IdentityCtrl', function($location, identity) {
	identity
		.$promise
		.then(function(me) {
			if ((me != null) && (me.groups != null)) {
				$location.path(`/user/${me.login}`);
				$location.replace();
			}
		});
});
